export default __webpack_public_path__ + "static/media/google.bd4ffdbf.svg";